import React from "react";
import { useTranslation } from "react-i18next";
import smartAlarm from "assets/img/smartAlarm.png";

const Step1 = React.forwardRef((props, ref) => {
  const { t } = useTranslation('wizard');
  const isValidated = () => {
      return true;
  };
  React.useImperativeHandle(ref, () => ({
    isValidated: () => {
      return isValidated();
    },
  }));
  return (
    <>
      <div className="info-text c-white">
        {t('alerts.step1Body')}
      </div>
      <div className="text-center">
        <img src={smartAlarm} alt="smart-alarm" />
      </div>
    </>
  );
});

export default Step1;
